import React, { useState, useEffect, useCallback, useRef } from "react";
import PageTabs from '../shared/PageTabs';
import { USERS_TABS } from '../shared/tabConfigs';
import {
  Box,
  Typography,
  Button,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
  IconButton,
  Chip,
  TextField,
  InputAdornment,
  MenuItem,
  Select,
  FormControl,
  Checkbox,
  Menu,
  ListItemIcon,
  ListItemText
} from "@mui/material";
import {
  Delete,
  People,
  Download,
  Search,
  Clear,
  Add,
  PersonAdd as PersonAddIcon,
  Person as PersonIcon,
  Add as AddIcon,
   Search as SearchIcon,
} from "@mui/icons-material";
import { groupService } from "../../services/api";
import { useToast } from "../../context/ToastContext";
import GroupForm from "./GroupForm";
import GroupUsersModal from "./GroupUsersModal";
import ConfirmDialog from "../common/ConfirmDialog";
import ImportAssignUsersModal from './ImportAssignUsersModal';
import BulkDeleteModal from "./BulkDeleteModal";
import '../../App.css';
import EmptyState from '../common/EmptyState';



const Groups = () => {
  const [groups, setGroups] = useState([]);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [totalGroups, setTotalGroups] = useState(0);
  const [searchTerm, setSearchTerm] = useState("");
  const [openCreateForm, setOpenCreateForm] = useState(false);
  const [openEditForm, setOpenEditForm] = useState(false);
  const [openUsersModal, setOpenUsersModal] = useState(false);
  const [selectedGroup, setSelectedGroup] = useState(null);
  const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
  const [filterType, setFilterType] = useState("0");
  const [sortBy, setSortBy] = useState("");
  const { showToast } = useToast();
  const [permissions, setPermissions] = useState({
    canCreate: false,
    canEdit: false,
    canDelete: false,
  });
  const [selectedGroups, setSelectedGroups] = useState([]);
  const [bulkDeleteModalOpen, setBulkDeleteModalOpen] = useState(false);
  const [formModalOpen, setFormModalOpen] = useState(false);
  const [importModalOpen, setImportModalOpen] = useState(false);
  // Refs for hover menus
  const assignUserRef = useRef(null);

  // Add state for Actions button menu
  const [actionsMenuAnchorEl, setActionsMenuAnchorEl] = useState(null);
  const isActionsMenuOpen = Boolean(actionsMenuAnchorEl);

  const [assignUserAnchorEl, setAssignUserAnchorEl] = useState(null);
  const isAssignUserMenuOpen = Boolean(assignUserAnchorEl);

  // Add state for role removal submenu
  const [removeUserAnchorEl, setRemoveUserAnchorEl] = useState(null);
  const isRemoveUserMenuOpen = Boolean(removeUserAnchorEl);

  const [addGroupMenuAnchor, setAddGroupMenuAnchor] = useState(null);

  // Add state for Add button menu
      const [addMenuAnchorEl, setAddMenuAnchorEl] = useState(null);
      const isAddMenuOpen = Boolean(addMenuAnchorEl);

  const fetchGroups = useCallback(async () => {
    try {
      setLoading(true);
      const response = await groupService.getGroups({
        page: page + 1,
        limit: rowsPerPage,
        searchTerm,
        filterType,
        sortBy,
      });

      if (response.data.success) {
        setGroups(response.data.groups);
        setTotalGroups(response.data.totalGroups);
        setPermissions(response.data.permissions);
      }
    } catch (error) {
      console.error("Error fetching cohorts:", error);
      showToast("Failed to load cohorts", "error");
    } finally {
      setLoading(false);
    }
  }, [page, rowsPerPage, searchTerm, filterType, sortBy, showToast]);

  useEffect(() => {
    fetchGroups();
  }, [fetchGroups]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
    setPage(0);
  };

  const handleClearSearch = () => {
    setSearchTerm("");
    setPage(0);
  };

  const handleCreateGroup = () => {
    setSelectedGroup(null);
    setOpenCreateForm(true);
  };

  const handleEditGroup = (group) => {
    setSelectedGroup(group);
    setOpenEditForm(true);
  };

  const handleViewGroupUsers = (group) => {
    setSelectedGroup(group);
    setOpenUsersModal(true);
  };

  const handleDeleteGroup = (group) => {
    setSelectedGroup(group);
    setOpenConfirmDialog(true);
  };

  // Actions button menu handlers
  const handleActionsMenuClick = (event) => {
    setActionsMenuAnchorEl(event.currentTarget);
  };

  const handleActionsMenuClose = () => {
    setActionsMenuAnchorEl(null);
  };
  // Role assignment menu handlers
  const handleAssignUserMenuOpen = (event) => {
    setAssignUserAnchorEl(event.currentTarget);
    setRemoveUserAnchorEl(null);
  };

  const handleAssignRoleMenuClose = () => {
    setAssignUserAnchorEl(null);
  };

  const handleRemoveRoleMenuClose = () => {
    setRemoveUserAnchorEl(null);
  };

  const handleAddGroupMenuClose = () => {
    setAddGroupMenuAnchor(null);
  };
  const handleAddGroupMenuClick = (event) => {
    setAddGroupMenuAnchor(event.currentTarget);
  };

  const handleAddMenuClose = () => {
        setAddMenuAnchorEl(null);
    };
 const handleCreateUser = () => {
        handleAddMenuClose();
        setSelectedGroup(null);
        setFormModalOpen(true);
    };

    const handleAddMenuClick = (event) => {
        setAddMenuAnchorEl(event.currentTarget);
    };

  // const confirmDeleteGroup = async () => {
  //   try {

  //     const response = await groupService.deleteGroup(selectedGroup.id);
  //     if (response.data.success) {
  //       showToast('Group deleted successfully', 'success');
  //       fetchGroups();
  //     }
  //   } catch (error) {
  //     console.error('Error deleting group:', error);
  //     showToast('Failed to delete group', 'error');
  //   } finally {
  //     setOpenConfirmDialog(false);
  //   }
  // };

  const handleFormSubmit = () => {
    fetchGroups();
    setOpenCreateForm(false);
    setOpenEditForm(false);
  };

  const handleFilterChange = (event) => {
    setFilterType(event.target.value);
    setPage(0);
  };

  const handleSortChange = (event) => {
    setSortBy(event.target.value);
    setPage(0);
  };

  // const handleBulkDelete = () => {
  //   handleActionsMenuClose();
  //   setBulkDeleteModalOpen(true);
  // };
  const handleBulkDelete = () => {
    handleActionsMenuClose();

    // Find selected group objects
    const selectedGroupObjects = groups.filter((group) =>
      selectedGroups.includes(group.id)
    );

    // Filter out non-custom groups
    const nonCustomGroups = selectedGroupObjects.filter(
      (group) => group.group_type !== "3"
    );

    if (nonCustomGroups.length > 0) {
      showToast("Only custom cohorts can be deleted", "warning");
      setSelectedGroups([]); // Deselect them
      return;
    }

    setBulkDeleteModalOpen(true); // Proceed to delete
  };

  const handleExportGroups = async (group) => {
    try {
      const response = await groupService.exportGroupData(group.id);
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;

      let filename = `cohort_${group.name}_users_export.csv`;
      const contentDisposition = response.headers["content-disposition"];
      if (contentDisposition) {
        const filenameMatch = contentDisposition.match(/filename="?([^"]*)"?/);
        if (filenameMatch && filenameMatch[1]) {
          filename = filenameMatch[1];
        }
      }

      link.setAttribute("download", filename);
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch (error) {
      console.error("Error exporting users:", error);
      showToast("Error exporting users", "error");
    }
  };

  const exportGroups = async () => {
    try {
      const response = await groupService.exportAllGroups({
        searchTerm,
        filterType: filterType !== "0" ? filterType : "",
        sortBy,
      });

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      let filename = "cohorts_export.csv";
      const contentDisposition = response.headers["content-disposition"];
      if (contentDisposition) {
        const filenameMatch = contentDisposition.match(/filename="?([^"]*)"?/);
        if (filenameMatch && filenameMatch[1]) {
          filename = filenameMatch[1];
        }
      }
      link.setAttribute("download", filename);
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch (error) {
      console.error("Error exporting cohorts:", error);
      showToast("Error exporting cohorts", "error");
    }
  };

  const handleExportSelectedGroups = async () => {
    handleActionsMenuClose();

    if (selectedGroups.length === 0) {
      showToast("Please select at least one cohort to export", "warning");
      return;
    }

    try {
      const response = await groupService.exportSelectedGroups(selectedGroups);

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;

      let filename = "selected_cohorts_export.csv";
      const contentDisposition = response.headers["content-disposition"];
      if (contentDisposition) {
        const filenameMatch = contentDisposition.match(/filename="?([^"]*)"?/);
        if (filenameMatch && filenameMatch[1]) {
          filename = filenameMatch[1];
        }
      }

      link.setAttribute("download", filename);
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch (error) {
      console.error("Error exporting selected cohorts:", error);
      showToast("Error exporting selected cohorts", "error");
    }
  };

  const handleExportCSV = () => {
    const headers = ["email_id", "cohort_name"];
    const csvContent = headers.join(",") + "\n";

    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "cohort_template.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    showToast("CSV template exported", "success");
  };

  const handleImportUsers = () => {
        handleAddMenuClose();
        setImportModalOpen(true);
    };

    const handleImportSuccess = () => {
        fetchGroups();
    };

  return (
    <Box sx={{ p: 2 }}>
      <PageTabs tabs={USERS_TABS} />
      <Typography variant="h4" gutterBottom className="page-title">
        Cohorts
      </Typography>
      <Box sx={{ display: "flex", justifyContent: "space-between", mb: 3 }}>
        <Box sx={{ display: "flex", gap: 2 }}>
          <TextField
            placeholder="Cohorts, Users"
            className="pink-filter"
            sx={{height: '35px'}}
            variant="outlined"
            size="small"
            value={searchTerm}
            onChange={handleSearchChange}
            InputProps={{
              startAdornment: (
                <InputAdornment position="end">
                  <SearchIcon/>
                </InputAdornment>
              ),
              endAdornment: searchTerm && (
                <InputAdornment position="end">
                  <IconButton size="small" onClick={handleClearSearch}>
                    <Clear />
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
          <FormControl
            // variant="outlined"
            className="pink-filter"
            size="small"
            sx={{ minWidth: 120 }}
          >
            <Select
              value={filterType}
              className="pink-filter"
              onChange={handleFilterChange}
              label="Filter Type"
            >
              <MenuItem value="0">All Cohorts</MenuItem>
              <MenuItem value="1">Role-based Cohorts</MenuItem>
              <MenuItem value="2">Field-based Cohorts</MenuItem>
              <MenuItem value="3">Custom Cohorts</MenuItem>
            </Select>
          </FormControl>

          <FormControl
            variant="outlined"
            size="small"
            sx={{ minWidth: 120 }}
          >
            <Select
              displayEmpty
              value={sortBy}
              className="pink-filter"
              onChange={handleSortChange}
              label="Sort By"
            >
              <MenuItem value="">Default</MenuItem>
              <MenuItem value="name asc">Name A-Z</MenuItem>
              <MenuItem value="name desc">Name Z-A</MenuItem>
              <MenuItem value="member_count asc">Users (Low to High)</MenuItem>
              <MenuItem value="member_count desc">Users (High to Low)</MenuItem>
            </Select>
          </FormControl>
        </Box>

        <Box>
          {selectedGroups.length > 0 && (
            <Button
              variant="outlined"
              onClick={handleActionsMenuClick}
              aria-controls={isActionsMenuOpen ? "actions-menu" : undefined}
              aria-haspopup="true"
              aria-expanded={isActionsMenuOpen ? "true" : undefined}
              sx={{ mr: 1 }}
            >
              Actions
            </Button>
          )}
          <Menu
            id="actions-menu"
            anchorEl={actionsMenuAnchorEl}
            open={isActionsMenuOpen}
            onClose={handleActionsMenuClose}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "right",
            }}
            transformOrigin={{
              vertical: "top",
              horizontal: "right",
            }}
          >
            <MenuItem
              onClick={() => {
                handleExportSelectedGroups(); // existing export function
                handleActionsMenuClose();
              }}
            >
              <Download fontSize="small" sx={{ mr: 1 }} />
              Export Cohorts
            </MenuItem>

            {permissions.canDelete && (
              <MenuItem
                onClick={handleBulkDelete}
                onMouseEnter={() => {
                  handleAssignRoleMenuClose();
                  handleRemoveRoleMenuClose();
                }}
              >
                <Delete fontSize="small" sx={{ mr: 1 }} />
                Delete Selected
              </MenuItem>
            )}
          </Menu>

          {/* <Button
            variant="outlined"
            startIcon={<Download />}
            onClick={exportGroups} sx={{ mr: 1 }}
          >
            Export Groups
          </Button> */}

          {permissions.canCreate && (
            
            <>
            <Button
              variant="outlined"
              startIcon={<PersonIcon />}
              sx={{ mr: 1 }}
              onClick={handleCreateGroup}
            >
              <b>Add Cohort</b>
            </Button>
            <Button
                variant="outlined"
                startIcon={<PersonAddIcon />}
                onClick={handleImportUsers}
                sx={{ mr: 1 }}
            >
                <b>Assign Users</b>
            </Button>
        </>
          )}
          {/* <MenuItem
            onClick={() => {
              handleExportCSV();
              handleAddGroupMenuClose();
            }}
          >
            Assign Users
          </MenuItem> */}
        </Box>
      </Box>

      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell padding="checkbox">
                <Checkbox
                  indeterminate={
                    selectedGroups.length > 0 &&
                    selectedGroups.length < groups.length
                  }
                  checked={
                    groups.length > 0 && selectedGroups.length === groups.length
                  }
                  onChange={(e) => {
                    if (e.target.checked) {
                      setSelectedGroups(groups.map((g) => g.id));
                    } else {
                      setSelectedGroups([]);
                    }
                  }}
                />
              </TableCell>
              <TableCell>Cohort Name</TableCell>
              <TableCell>Description</TableCell>
              <TableCell>No. of Users</TableCell>
              <TableCell>Type</TableCell>
              <TableCell align="right">Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {loading ? (
              <TableRow>
                <TableCell colSpan={5} align="center">
                  Loading...
                </TableCell>
              </TableRow>
            ) : groups.length === 0 ? (
              <TableRow>
                <TableCell colSpan={5} align="center">
                  {/* The shared empty state with this screen's own words (K2.3 pt 14). Removed 23 Oct 2026 (K2.3 pt 14): a plain line. */}
                  <EmptyState framed={false} title="No cohorts found" message={null} />
                </TableCell>
              </TableRow>
            ) : (
              groups.map((group) => (
                <TableRow
                  key={group.id}
                  hover
                  selected={selectedGroups.includes(group.id)}
                >
                  <TableCell padding="checkbox">
                    <Checkbox
                      checked={selectedGroups.includes(group.id)}
                      onChange={() => {
                        if (selectedGroups.includes(group.id)) {
                          setSelectedGroups(
                            selectedGroups.filter((id) => id !== group.id)
                          );
                        } else {
                          setSelectedGroups([...selectedGroups, group.id]);
                        }
                      }}
                    />
                  </TableCell>
                  <TableCell>
                    {permissions.canEdit && group.group_type === "3" ? (
                      <Box
                        sx={{
                          cursor: "pointer",
                          color: "primary.main",
                        }}
                        onClick={() => handleEditGroup(group)}
                      >
                        {group.name}
                      </Box>
                    ) : (
                      <Box>{group.name}</Box>
                    )}
                  </TableCell>
                  <TableCell>{group.description}</TableCell>
                  <TableCell>
                    {group.member_count > 0 ? (
                      <Chip
                        label={group.member_count}
                        size="small"
                        color="default"
                        onClick={() => handleViewGroupUsers(group)}
                        sx={{ cursor: "pointer"}}
                      />
                    ) : (
                      <Chip label={group.member_count} size="small" />
                    )}
                  </TableCell>                  
                  <TableCell>
                    {group.audience_type === "1"
                      ? "Internal"
                      : group.audience_type === "2"
                      ? "External"
                      : " - "
                    }
                    </TableCell>
                  <TableCell align="right">
                    <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
                      <IconButton
                        size="small"
                        onClick={() => handleExportGroups(group)}
                        title="Export Members"
                      >
                        <Download fontSize="small" />
                      </IconButton>
                    </Box>
                  </TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
        <TablePagination
          rowsPerPageOptions={[5, 10, 25]}
          component="div"
          count={totalGroups}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </TableContainer>

      {openCreateForm && (
        <GroupForm
          open={openCreateForm}
          onClose={() => setOpenCreateForm(false)}
          onSubmit={handleFormSubmit}
        />
      )}

      {openEditForm && selectedGroup && (
        <GroupForm
          open={openEditForm}
          onClose={() => setOpenEditForm(false)}
          onSubmit={handleFormSubmit}
          group={selectedGroup}
        />
      )}

      {openUsersModal && selectedGroup && (
        <GroupUsersModal
          open={openUsersModal}
          onClose={() => setOpenUsersModal(false)}
          groupId={selectedGroup.id}
        />
      )}


      <ImportAssignUsersModal
        open={importModalOpen}
        onClose={() => setImportModalOpen(false)}
        onSuccess={handleImportSuccess}
      />

      <BulkDeleteModal
        open={bulkDeleteModalOpen}
        onClose={() => setBulkDeleteModalOpen(false)}
        ids={selectedGroups} //  generic prop name
        onSuccess={() => {
          showToast("Cohorts deleted successfully", "success"); //  message corrected
          setBulkDeleteModalOpen(false);
          fetchGroups();
          setSelectedGroups([]);
        }}
        deleteFunction={groupService.bulkDeleteGroups} //  API function
        title="Delete Cohorts"
        itemName="group"
      />
    </Box>
  );
};

export default Groups;